import { render, staticRenderFns } from "./change-password.vue?vue&type=template&id=5fd315a4&scoped=true"
import script from "./change-password.vue?vue&type=script&lang=js"
export * from "./change-password.vue?vue&type=script&lang=js"
import style0 from "./change-password.vue?vue&type=style&index=0&id=5fd315a4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd315a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fd315a4')) {
      api.createRecord('5fd315a4', component.options)
    } else {
      api.reload('5fd315a4', component.options)
    }
    module.hot.accept("./change-password.vue?vue&type=template&id=5fd315a4&scoped=true", function () {
      api.rerender('5fd315a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/detail-pane/change-password.vue"
export default component.exports